import { PendingPaymentModalMeta } from "@/Components/Modals/PendingPaymentModal";
import { useSetPriorityModal } from "../atoms/usePriorityModal";
import { pusherClient } from "../socket";
import useBranchId from "./useBranchId";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useEffect, useRef } from "react";

const usePosOrderPendingPaymentSocket = ({
  callback,
  eventName,
}: PendingPaymentModalMeta) => {
  const { t } = useTranslation();
  const branch = useBranchId();
  const setPriorityModal = useSetPriorityModal();
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    if (branch == -1 || !eventName) return;

    const branchChannel = `branch-${branch}`;
    // Subscribe here so payment success works even when global <Pusher />
    // is not mounted (e.g. kiosk users without ROLE_ORDER_TRACKER).
    const channel = pusherClient.subscribe(branchChannel);

    const handler = () => {
      setPriorityModal("", {});
      callbackRef.current?.();
      toast.success(t("posOrders.paymentSuccessful"));
    };

    channel.bind(eventName, handler);

    return () => {
      channel.unbind(eventName, handler);
    };
  }, [branch, eventName, setPriorityModal, t]);
};

export default usePosOrderPendingPaymentSocket;
